export default __webpack_public_path__ + "static/ruby-236bf9789e63a4738d96bf4421662b97.svg";